<template>
    <Row type="form-row">
        <SelectBox
                sm-size="8"
                :errors="errors"
                :label="label"
                :model-form="modelForm"
                :model-name="modelName"
                :getter-name="getterName"
                :fetch-name="fetchName"
                :after-fetch="afterFetch"
                :options="options"
                :check-to-model="checkToModel"
                :text-field="textField"
                :value-field="valueField"
                :no-margin-top="noMarginTop"
        />

        <Column
                v-if="urlToAdd !== undefined"
                sm-size="2"
        >
            <LabelTag :xs-display="false" :sm-display="true" color="light">-</LabelTag>
            <ButtonTag :url="urlToAdd" :is-w100="true"  >
                <TextTag :xs-display="false" :sm-display="true">
                    &plus; {{ $t('new') }}
                </TextTag>
                <TextTag :sm-display="false">
                    {{ $t(addText) }}
                </TextTag>
            </ButtonTag>
        </Column>
    </Row>
</template>

<script>
    import validatorMixin from "../mixin/validatorMixin";
    import Column from "./html/Column";
    import Row from "./html/Row";
    import SelectBox from "./SelectBox";
    import ButtonTag from "./html/ButtonTag";
    import TextTag from "./html/TextTag";
    import LabelTag from "@/components/html/LabelTag";

    export default {
        name: "SelectBoxAndAddButton",
        components: {Column, LabelTag, TextTag, ButtonTag, SelectBox, Row},
        mixins: [validatorMixin],
        props: {
            errors: {
                type: Object,
                required: true,
            },
            label: {
                type: String,
            },

            // optional
            urlToAdd: {
                type: String,
                default: undefined,
            },
            addText: {
                type: String,
                default: 'add'
            },
            options: {
                type: Array,
                required: false,
                default: null,
            },
            checkToModel: {
                type: String,
                default: "modelChooseIdState"
            },
            fetchName: {
                type: String,
                default: undefined,
            },
            getterName: {
                type: String,
                default: undefined,
            },
            afterFetch: {
                type: Function,
                default: (items) => {
                    console.log(items)
                }
            },
            noMarginTop: {
                type: Boolean,
                default: true
            },
            modelName: {
                type: String,
            },
            modelForm: {
                type: Object,
            },
            valueField: {
                type: String,
                default: "id",
            },
            textField: {
                type: String,
                default: "name",
            },
        },
    }
</script>

<style scoped>

</style>